import React from 'react';
import '../../css/AdminServiceCompanyRelative.css';

export const AdminServiceCompanyRelative = ({ company }) => {
    return (
        <div className="adminServiceCompanyRelativeContainer" key={company.id}>
            <div className="adminServiceCompanyRelativeDetail">Name: {company.name}</div>
            <div className="adminServiceCompanyRelativeDetail">Status: {company.status}</div>
            <div className="adminServiceCompanyRelativeDetail">Created Date: {new Date(company.created_at).toLocaleString()}</div>
            <div className="adminServiceCompanyRelativeDetail">Updated Date: {new Date(company.updated_at).toLocaleString()}</div>
        </div>
    );
};
